import type { DocCategory } from '../registry';
import { ReleaseNotes } from '../ReleaseNotes';

// Single page: the Body is the data-driven <ReleaseNotes/> list, so it carries no
// DocSection outline (toc stays empty and the right rail is hidden for it).
export const releaseNotes: DocCategory = {
  id: 'release-notes',
  label: 'Release notes',
  pages: [
    {
      slug: 'release-notes',
      title: 'Release notes',
      eyebrow: 'Release notes',
      description: 'What shipped in each ClipRadar beta build, newest first.',
      toc: [],
      Body: ReleaseNotes,
      related: [
        { label: 'Known issues', to: '/docs/troubleshooting/known-issues' },
        { label: 'Frequently asked questions', to: '/docs/faq' },
      ],
    },
  ],
};
